<!--
  +---------------------------------------------------------------------------------------
  | @Author:    xander<luoxingzhang@frippler.com>
  | @Title:     设备增值-收费方案
  +---------------------------------------------------------------------------------------
-->
<template>
  <div class="ei-scheme">
    <div class="filter-container">
      <div class="filter-box">
        <div class="filter-item sm" style="width:160px">
          <el-input v-model="query.keyword" placeholder="名称" prefix-icon="el-icon-search" clearable @change="fetchData()" />
        </div>
      </div>
      <div class="toolbox">
        <el-button icon="el-icon-plus" type="success" @click="newScheme = true">新方案</el-button>
      </div>
    </div>

    <el-card v-loading="loading" shadow="never">
      <el-row v-if="schemes.length" :gutter="20">
        <el-col v-for="(item, i) in schemes" :key="i" :lg="6" :md="8" :sm="12">
          <div class="el-card-content" role="button" style="width:100%"
            @click="$router.push('/ei/scheme/detail?schemeid=' + item.schemeid)">
            <div ref="col"
              :style="{ height: height + 'px', backgroundImage: `url(${require('../../assets/' + (item.scheme_params[0].unit == 'year' ? 'card-ap-year.jpg' : item.scheme_params[0].unit == 'month' ? 'card-ap-month.jpg' : 'card-ap-once.jpg'))})` }"
              class="charge_card text-black mb-lg">
              <div class="flex column card_container">
                <div>
                  <div class="flex">
                    <div class="bd font-lg text-bold ellipsis">{{ item.title }}</div>
                    <div class="ft">
                      <div
                        v-if="item.activity_enable && item.activity_params.title && item.activity_params.endtime && time < item.activity_params.endtime && time > item.activity_params.starttime"
                        class="activity text-white">{{ item.activity_params.title }}</div>
                    </div>
                  </div>
                  <div class="flex mt-xs">
                    <el-tooltip v-if="service === item.schemeid ? true : false" effect="dark" content="点击取消"
                      placement="top">
                      <span role="button" class="default_item first_item flex-center font-sm"
                        @click.stop="chooseService(item.schemeid)">默认服务</span>
                    </el-tooltip>
                    <span v-if="service === item.schemeid ? false : true" role="button"
                      class="default_item third_item flex-center font-sm" @click.stop="chooseService(item.schemeid)">{{ servicechoose }}</span>
                  </div>
                  <div
                    v-if="item.activity_enable && item.activity_params.endtime && time < item.activity_params.endtime && time > item.activity_params.starttime">
                    <div class="deadline text-black">
                      活动截止: {{ item.activity_params.endtime | parseTime('{y}/{m}/{d} {h}:{i}:{s}') }}
                    </div>
                    <div v-if="item.activity_params.advanced_price_enable" class="promotion text-black">
                      一年单价￥{{ item.activity_params.advanced_prices.one_year }}；两年单价￥{{ item.activity_params.advanced_prices.two_year }}；三年单价￥{{ item.activity_params.advanced_prices.three_year }}
                    </div>
                  </div>
                </div>
                <div v-if="item.schemeid == 1" class="lock">
                  <i class="el-icon-lock"></i>
                </div>
                <div
                  v-if="item.activity_enable && item.activity_params.endtime && time < item.activity_params.endtime && time > item.activity_params.starttime"
                  class="flex container_foot">
                  <div class="flex container_foot">
                    <span class="font-2x text-bold">{{ item.activity_params.discount_price | currency }}</span>
                    <span v-if="item.scheme_params[0].unit === 'year'" class="font-md">/年</span>
                    <span v-if="item.scheme_params[0].unit === 'month'" class="font-md">/月</span>
                    <span v-if="item.scheme_params[0].unit === 'once'" class="font-md">/次</span>
                  </div>
                  <div class="flex container_foot ml-xs originalPrice">
                    <span>{{ item.scheme_params[0].price | currency }}{{
                      item.scheme_params[0].unit ===
                        'year' ? '/年' : item.scheme_params[0].unit === 'month' ? '/月' : '/次'
                    }}</span>
                  </div>
                </div>
                <div v-else class="flex container_foot">
                  <span class="font-2x text-bold">{{ item.scheme_params[0].price | currency }}</span>
                  <span v-if="item.scheme_params[0].unit === 'year'" class="font-md">/年</span>
                  <span v-if="item.scheme_params[0].unit === 'month'" class="font-md">/月</span>
                  <span v-if="item.scheme_params[0].unit === 'once'" class="font-md">/次</span>
                </div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>

      <div v-else class="flex-center column">
        <div class="flex-center mt-hg">
          <img src="../../assets/no-data.png" alt="" class="no-data">
        </div>
        <div class="flex-center">
          <i class="el-icon-warning-outline font-lg mr-xs text-muted"></i>
          <span class="flex justify-content-center mt-lg mb-lg font-md text-muted">暂无收费方案，请点击右上角按钮新建方案</span>
        </div>
      </div>
    </el-card>

    <clause v-if="newScheme" :show.sync="newScheme" />
  </div>
</template>

<script>
import { schemeListApi, eiChargeDefault } from "@/api/ei/eiApi";

export default {
  name: "EiScheme",

  components: {
    Clause: () => import("./components/EiClause")
  },

  data() {
    return {
      type: null,
      loading: false,
      newScheme: false,
      query: {
        keyword: "",
        psize: 99
      },
      schemes: [],
      multiSelection: [],
      time: parseInt(new Date().valueOf() / 1000),
      service: 0,
      authorize: 0,
      width: 0,
      height: 225
    };
  },

  computed: {
    servicechoose: function () {
      return "设置默认服务";
    },
    authorizechoose: function () {
      return "设置默认授权";
    }
  },
  watch: {
    width: function () {
      this.height = this.$refs.col[0].clientWidth / 1.6;
    }
  },

  created() {
    this.fetchData();
  },
  mounted() {
    window.onresize = () => {
      this.width = this.$refs.col[0].clientWidth;
    };
  },

  methods: {
    fetchData() {
      this.loading = true;
      schemeListApi(this.query).then(res => {
        this.loading = false;
        if (res.errno === 0) {
          this.service = res.data.service;
          this.authorize = res.data.authorize;
          this.schemes = res.data.list;
          this.$nextTick(() => {
            if (this.schemes.length) {
              this.width = this.$refs.col[0].clientWidth;
              this.height = this.width / 1.6;
            }
          });
        } else {
          this.$message.error(res.message);
        }
      });
    },

    pushData(data) {
      eiChargeDefault(data).then(res => { });
    },

    chooseService(id) {
      if (id === this.service) {
        this.service = 0;
        this.pushData({ service: this.service });
        return false;
      }
      this.service = id;
      this.pushData({ service: this.service });
    }
    // chooseAuthorize(id) {
    //   if (id === this.authorize) {
    //     this.authorize = 0
    //     this.pushData({ authorize: this.authorize })
    //     return false
    //   }
    //   this.authorize = id
    //   this.pushData({ authorize: this.authorize })
    // }
  }
};
</script>

<style lang="scss" scoped>
.container_foot {
  .font-2x {
    font-size: 2em;
    line-height: 24px;
  }
}

.number-price {
  line-height: 17px;
}
</style>

<style lang="scss" slot-scoped>
.ei-scheme {
  margin-bottom: -60px;

  .el-scrollbar {
    height: 460px;

    >.el-scrollbar__wrap {
      overflow-x: hidden;

      >.el-scrollbar__view {
        padding: 0 10px 0px 0;
      }
    }
  }

  .el-card-content {
    display: flex;
    flex-wrap: wrap;
    position: relative;

    .activity {
      position: relative;
      top: -15px;
      right: -15px;
      padding: 0 10px;
      height: 36px;
      line-height: 36px;
      text-align: center;
      font-size: 14px;
      border-radius: 0px 20px 0px 20px;
      background: linear-gradient(to right, #ff7400, #ffae0c);
    }
  }

  .charge_card {
    width: 100%;
    padding: 15px;
    border-radius: 20px;
    position: relative;
    background-repeat: no-repeat;
    background-size: 100% 100%;

    .card_container {
      height: 100%;
      justify-content: space-between;

      .deadline {
        position: absolute;
        top: 75px;
        left: 15px;
        font-size: 12px;
      }

      .promotion {
        position: absolute;
        top: 100px;
        left: 15px;
        padding-right: 10px;
        font-size: 12px;
      }

      .default_item {
        position: absolute;
        width: 70px;
        height: 20px;
        top: 50px;
        margin-right: 10px;
        border-radius: 10px;
      }

      .lock {
        position: absolute;
        bottom: 10px;
        left: 15px;
        font-size: 30px;
        color: white;
      }

      .first_item {
        background: #e64340;
      }

      .second_item {
        background: #409eff;
      }

      .third_item {
        display: none;
      }

      .fourth_item {
        display: none;
      }

      .container_foot {
        justify-content: flex-end;
        align-items: flex-end;

        .originalPrice {
          text-decoration: line-through;
          font-size: 14px;
          color: #333;
        }
      }
    }

    .container_close {
      position: absolute;
      top: 2px;
      right: 2px;

      .close_btn {
        visibility: hidden;
      }
    }
  }

  .charge_card:hover .close_btn {
    visibility: inherit;
  }

  .charge_card:hover {
    .default_item {
      transition: 0.5s;
    }

    .third_item {
      width: 95px;
      display: inherit;
      color: #e64340;
      border: 0.5px solid #e64340;
      background-color: rgba($color: #fff, $alpha: 0.9);
    }

    .fourth_item {
      width: 95px;
      display: inherit;
      color: #409eff;
      border: 0.5px solid #409eff;
      background-color: rgba($color: #fff, $alpha: 0.9);
    }
  }
}

.line-through {
  text-decoration: line-through;
}

.h7 {
  font-size: 14px;
}
</style>
